export { ModularPageWrapper, ModulePageComponents } from './ModularPageWrapper';
export type { ModularPageWrapperProps } from './ModularPageWrapper';
